import useSearchParams from 'modules/core/hooks/useSearchParams'

interface Params {
  incidenceType: string
}

const useIncidenceTypeQueryParam = () => {
  const { incidenceType } = useSearchParams<Params>()

  return { incidenceType }
}

export default useIncidenceTypeQueryParam
